import React, { FC, FormEvent, useEffect, useState } from "react"
import Breadcrumb from "../../../components/common/Breadcrumbs";
import { useFindUserSettingsByGroupNameQuery } from "../../../components/common/userSetting/userSettingsApi";
import { createClickableLink } from "../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../components/common/datatable/filter/SearchInputWrapper";
import { DataTable } from "../../../components/common/datatable/DataTable";
import { FaTrash } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import {
    useDeleteHighRiskAccountVerifiedByIdMutation,
    useSearchHighRiskAccountsVerifiedQuery
} from "./highRiskAccountVerifiedApi";
import { formatValueAsDateAndTime } from "../../../helpers/utils/DateUtils";
import { SearchDatePickerWrapper } from "../../../components/common/datatable/filter/SearchDatePickerWrapper";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import ModalButton from "../../../components/common/form/ModalButton";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import CollectorSearchInputWrapper from "../../../components/common/datatable/filter/CollectorSearchInputWrapper";

const HighRiskAccountVerified: FC = () => {
    const [selectedHighRiskAccountVerifiedId, setSelectedHighRiskAccountVerifiedId] = useState("");
    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("High Risk Account Verified");

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "High Risk Account Verified", url: "" },

    ])
    useEffect(() => {
        document.title = "High RiskAccount Verified";
    });
    const [deleteHighRiskAccountVerifiedApi, { isLoading: deleteHighRiskAccountVerifiedApiResponse }] = useDeleteHighRiskAccountVerifiedByIdMutation();

    const handleDeleteMemberSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (selectedHighRiskAccountVerifiedId) {
            return deleteHighRiskAccountVerifiedApi(selectedHighRiskAccountVerifiedId);
        }
    }

    const columns: DataTableColumn[] = [
        {
            label: "Collector",
            accessor: "collectorName",
            visibility: { hasShowSetting: false },
            cell: (props: any) => {
                let path = `/collectors/${props.row.original.collectorId}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["COLL-R"]);
            },
            canSort:false,
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorId" />,
                overrideFilterAccessor: "collectorId",
                overrideFilterLabel: "Collector",
            }]
        },

        {
            label: "Tax Account No.", accessor: "taxAccountNumber",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Tax Account No..."}
                    name={"taxAccountNumber"} accessor={"taxAccountNumber"} />
            }]
        },

        {
            label: "Created By", accessor: "createdBy",
            visibility: { hasShowSetting: false },
            canSort: false,
            // filterOptions: [{
            //     filterComponent: SearchSelectWithList(stateQueryApi?.data, "username", "id", "Select Created By...", false, "createdBy"),
            // }]
        },
        {
            label: "Created Date", accessor: "creationDate",
            cell: (props: any) => {
                return formatValueAsDateAndTime(props.row.original.creationDate);
            },
            filterOptions: [
                {
                    filterComponent: <SearchDatePickerWrapper accessor={"createdDateFrom"} />,
                    overrideFilterAccessor: "createdDateFrom",
                    overrideFilterLabel: "Created Date - From",
                },
                {
                    filterComponent: <SearchDatePickerWrapper accessor={"createdDateTo"} />,
                    overrideFilterAccessor: "createdDateTo",
                    overrideFilterLabel: "Created Date - To",
                }],
        },
        {
            label: "Note", accessor: "note",
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Note..."}
                    name={"note"} accessor={"note"} />
            }]
        },
        {
            label: "Action", visibility: {
                canColumnShow: hasPermission(["HRAV-D"]),
                showByDefault: hasPermission(["HRAV-D"]),
                hasShowSetting: false,
            },
            accessor: "id",
            canSort: false,
            cell: (props: any) => {
                return <>
                    <div className="ml-4">
                        <ModalButton
                            triggerButton={
                                <FaTrash
                                    className={"cursor-pointer text-highlight-0 text-lg hover:text-highlight-7"}
                                    title={"Delete High Risk Account Verified"} />
                            }
                            onOpen={() => {
                                setSelectedHighRiskAccountVerifiedId(props.row.original.id)
                            }}
                            modal={
                                <ConfirmationModal
                                    show={true}
                                    setShow={() => {
                                    }}
                                    title={"Delete High Risk Account Verified"}
                                    bodyMessage={`Are you sure you want to remove this high risk account verified?`}
                                    onSubmit={handleDeleteMemberSubmit}
                                    isLoading={deleteHighRiskAccountVerifiedApiResponse}
                                />
                            }
                        />
                    </div>
                </>
            }
        }
    ]

    return (

        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchHighRiskAccountsVerifiedQuery
                }}
                userSettingGroup={"High Risk Account Verified"}
                defaultSortOptions={{
                    accessor: "creationDate",
                    direction: "asc"
                }}

                appendFilterToUrl={false}
            />

        </div>

    )
}
export default HighRiskAccountVerified;